import { render, staticRenderFns } from "./UtmPopup.vue?vue&type=template&id=4be4bb13&lang=pug&"
import script from "./UtmPopup.vue?vue&type=script&lang=js&"
export * from "./UtmPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports